<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import emitHypotheticalEvent from "../tracking/trackHypothetical.js";

    let { data } = $props();
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let index = $state(0);
    let eventMergeId = $state("");

    const {
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        hasPersonalisedRecommendations = false,
    } = data;

    let cinemaContainer;
    let mountSuccess;
    let cinemaContainerMounted = new Promise((resolve) => {
        mountSuccess = resolve;
    });

    onMount(async () => {
        emitHypotheticalEvent("RecoBasketNotPresent");
        if (!data.onlyEmitHypotheticalTracking) {
            attachParentVisibilityObserver(cinemaContainer);
            featureIndex = cinemaContainer?.parentElement?.dataset?.featureOrder || "99";
            index = cinemaContainer?.parentElement?.dataset?.index || 0;
            eventMergeId = document.getElementsByClassName("or_js_eventMergeId")?.[0]?.dataset?.eventMergeId;
            cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
            mountSuccess();
        }
    });

    const attachParentVisibilityObserver = (targetElement) => {
        if (targetElement?.parentNode) {
            const parentObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const isParentVisible = mutation.target.style.display !== "none";
                    if (isParentVisible) {
                        cinemaInjectionContainerWidth = targetElement.offsetWidth;
                    }
                });
            });
            parentObserver.observe(targetElement.parentNode, {
                attributes: true,
                attributeFilter: ["class"],
            });
        }
    };
</script>

{#if !data.onlyEmitHypotheticalTracking}
    <div bind:this={cinemaContainer}>
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            trackingEventMergeId={eventMergeId}
            loadedTrackingActionName="delete"
            site="reco_emptyBasket"
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
        />
    </div>
{/if}
